import React from 'react';
import { arrayOf, object, string, number, bool, oneOf, func, shape } from 'prop-types';
import classnames from 'classnames';
import { Popover } from '@fiverr-private/fit';
import ClientLogo from '../ClientLogo';
import DetailsPopover from '../DetailsPopover';
import { getClientLogoPath } from '../../../utils/helpers/notableClients';
import './style.scss';

const ClientList = ({
    displayClients = [],
    sellerName,
    profilePhoto,
    logoSize,
    logoClassName,
    showCompanyNames = true,
    showIndustry = false,
    popoverDelay = 0,
    popoverPositionFunction,
    hidePopover = false,
    clientHoverCallback = () => null,
    detailsPopoverProps = {}
}) => (
    <>
        { displayClients.map((client, index) => {
            const { name, industry } = client.enriched_details;
            const logoPath = getClientLogoPath(client);
            const logoProps = {
                logoPath,
                name,
                size: logoSize,
                logoClassName
            };
            const popoverProps = {
                sellerName, profilePhoto, client, detailsPopoverProps
            };
            const popoverPosition = popoverPositionFunction(index);
            const containerClassName = classnames('notable-clients-popover-container',
                { 'popover-container-closer': popoverPosition === Popover.POSITIONS.RIGHT });
            const clientComponent = (<>
                <div className="logo-wrap">
                    <ClientLogo key={logoPath} {...logoProps}/>
                </div>
                {showCompanyNames && <div className="client-details">
                    <p className="client-name" title={name}>{name}</p>
                    { showIndustry && <p className="industry" title={industry}>{industry}</p> }
                </div>}
            </>);

            return (hidePopover ?
                (<li className={classnames('notable-client-in-list', 'list-item-pop-over')} key={client.website}>{clientComponent}</li>) :
                (<li key={client.website}>
                    <Popover className="notable-clients-popover"
                        contentClassName="notable-client-in-list"
                        containerClassName={containerClassName}
                        trigger={Popover.TRIGGERS.HOVER}
                        delay={popoverDelay}
                        position={popoverPosition}
                        allowOverflow={!!popoverPosition}
                        content={<DetailsPopover {...popoverProps}/>}
                        onOpen={() => clientHoverCallback(client, index + 1)}>
                        {clientComponent}
                    </Popover>
                </li>));
        })}
    </>
);

ClientList.propTypes = {
    displayClients: arrayOf(object),
    sellerName: string,
    profilePhoto: string,
    logoSize: oneOf(Object.values(ClientLogo.SIZES)),
    logoClassName: string,
    showCompanyNames: bool,
    showIndustry: bool,
    popoverDelay: number,
    popoverPositionFunction: func.isRequired,
    clientHoverCallback: func,
    hidePopover: bool,
    detailsPopoverProps: shape({
        title: string
    })
};

export default ClientList;
